module.exports = __webpack_public_path__ + "img/ic_process_no4.6e36d118.png";